<template>
  <div class="pageContent">
    <inspectionReport v-if="Storage.get('code') != 2 && Storage.get('examStatus') != 1" />
  </div>
</template>
<script>
import inspectionReport from '@/components/reportInfo/inspectionReport.vue'
import Storage from '@/tools/storage'
export default {
  name: 'reportInfo',
  components: { inspectionReport },
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
